<template>
	<div class="fancy-field" :class="{'has-data':hasData(name),'select':type=='select','has-error':hasError,'has-placeholder':placeholder,'has-label':label}">
		<label :for="name" @click="setFocus(name)">
			{{label || placeholder}}
			<span v-if="required">*</span>
			<i class="icon fancy-field__help" :aria-label="help" data-tooltip v-if="help">help</i>
		</label>

		<div class="fancy-field__input">
			<slot name="pre" class="fancy-field__pre"></slot>
			<input ref="input" :type="inputType" :name="name" :id="name" :value="value" @input="$emit('input', $event.target.value)" class="fancy-control" :required="required" :disabled="disabled" :placeholder="placeholder" :autocomplete="autocomplete" v-if="type!=='select'&&type!=='date'" :readonly="readonly">
			<slot name="post" class="fancy-field__post"></slot>
			<i class="icon fancy-field__show" v-if="type==='password'" @click="passwordToggle()" v-html="passwordVisible?'visibility_off':'visibility'">visibility</i>
		</div>

		<div class="fancy-field__input">
			<select ref="input" :name="name" :id="name" :value="value" @change="$emit('input', $event.target.value)" class="fancy-control" :required="required" :disabled="disabled" v-if="type=='select'">
				<slot></slot>
			</select>
		</div>

		<div class="fancy-msg" :class="{'fancy-msg--error':hasError,'fancy-msg--hint':hint}"><slot name="msg">{{hint}}</slot></div>
	</div>
</template>

<script>
	// import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'

	// Export
	export default {
		name: 'fancyInput',
		props: {
			autocomplete: String,
			type: String,
			name: String,
			label: String,
			placeholder: String,
			required: null,
			help: String,
			hint: String,
			disabled: {
				type: Boolean,
				default: () => (false),
			},
			value: {
				type: [String, Number, Boolean, Object, Array],
				default: () => (null),
			},
			hasError: Boolean,
			readonly: Boolean,
		},
		components: {
			// DatePicker,
		},
		data: () => ({
			startTime: {
				time: '',
			},
			passwordVisible: false,
		}),
		mounted() {
			if (!this.$refs || !this.$refs.input) return

			if (this.$refs.input.value || this.$refs.input.selectedIndex === 0) {
				const parent = this.$refs.input.parentNode.parentNode
				parent.classList.add('has-data')
			}

			this.$refs.input.addEventListener('focus', e => {
				const parent = e.target.parentNode.parentNode
				parent.classList.add('has-focus')
				parent.classList.add('has-data')
			})

			this.$refs.input.addEventListener('blur', e => {
				const parent = e.target.parentNode.parentNode
				parent.classList.remove('has-focus')
				if (!e.target.value && e.target.selectedIndex !== 0) {
					parent.classList.remove('has-data')
				}
			})
		},
		methods: {
			hasData(field) {
				switch (typeof this.value) {
				case 'number':
					return this.value > -1
				default:
					return (this.value || '').length
				}
			},
			setFocus(field) {
				this.$refs.input.focus()
			},
			updateValue(e) {
				this.$emit('input', e.target.value)
				// this.$refs.input.value = val
			},
			passwordToggle() {
				this.passwordVisible = !this.passwordVisible
			},
		},
		computed: {
			inputType() {
				if (this.type === 'password' && this.passwordVisible) return 'text'
				return this.type
			},
		},
	}
</script>

<style scoped lang="scss">
	.fancy {

		&-field {
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			position: relative;
			transition: all 250ms $easing-material;
			width: 100%;
			@include gutter('margin-bottom');
			@include gutter('margin-top');
			@include gutter('padding-bottom');

			label {
				@include gutter('bottom');
				color: color_('text');
				cursor: text;
				font-size: $base-font-size;
				opacity: 0.7;
				padding: 0;
				position: absolute;
				transform: translate3d(0,0,0) scale3d(1,1,1);
				transform-origin: left top;
				transition: all 250ms $easing-material;
				z-index: 10;
				text-transform: uppercase;
			}

			&:after {
				background-color: color_('primary');
				content: '\00a0';
				display: block;
				position: absolute;
				@include gutter('bottom');
				height: 2px;
				z-index: 11;
				width: 100%;
				transform: scaleX(0);
				transform-origin: center top;
				transition: transform 250ms $easing-material;
			}

			&.has-focus,
			&.has-data,
			&.has-placeholder {
				label {
					opacity: 1;
					transform: translate3d(0,-130%,0) scale3d(0.85,0.85,0.85);
				}
			}

			&.has-label {
				&.select {
					label {
						opacity: 1;
						transform: translate3d(0,-130%,0) scale3d(0.85,0.85,0.85);
					}
				}
			}

			&.has-focus {
				border-bottom-color: color_('primary');

				label {
					color: color_('primary');
					span {
						color: color_('alert','error');
					}
				}

				&:after {
					transform: scaleX(1);
				}
			}

			&.has-error {
				border-bottom-color: color_('alert','error');
				label {
					color: color_('alert','error');
				}

				&:after {
					background-color: color_('alert','error');
					transform: scaleX(1);
				}
			}

			select {
				background-image: url('data:image/svg+xml;utf-8,<svg fill="%23000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
				background-repeat: no-repeat;
				background-position: right center;
				cursor: pointer;
				outline: none;
			}

			&__input {
				display: flex;
				flex-direction: row;
				width: 100%;
			}

			&__pre {
				@include gutter('margin-right',0.5);

				&.icon {
					color: color_('background','dark');
				}
			}
			&__post {
				@include gutter('margin-left',0.5);

				&.icon {
					color: color_('background','dark');
				}
			}

			&__help {
				color: color_('text','light');
				font-size: 16px;

				.has-focus &,
				.has-data &,
				.has-placeholder & {
					transform: scale3d(1.15,1.15,1.15);
				}
			}

			&__show {
				color: color_('text','light');
				cursor: pointer;
				font-size: 16px;
			}

			.header__search & {
				label {
						display: none;
					}

				&.has-focus,
				&.has-data, {
					label {
						display: none;
					}
				}
			}
		}

		&-control {
			appearance: none;
			background-color: transparent;
			border: 0;
			border-color: transparent;
			border-bottom: 1px solid rgba(100,100,100,0.25);
			border-radius: 0;
			box-shadow: none;
			color: color_('text');
			flex: 1;
			font-size: $base-font-size;
			outline: 0;
			padding: $line-sm/2 0;
			font-family: $font-family;

			&::placeholder {
				color: color_('text','xlight');
			}

			.has-error & {
				border-bottom-color: color_('alert','error');
			}

			&:disabled {
				cursor: disabled;
				opacity: 0.7;
				pointer-events: none;
			}
		}

		&-msg {
			@include font-size('small');
			background-color: transparent;
			border: 1px solid transparent;
			border-radius: 2px;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
			border-top: 0;
			bottom: 0;
			box-sizing: border-box;
			color: color_('text','light');
			left: 0;
			right: 0;
			margin: 0;
			opacity: 0;
			@include gutter('padding-top',0.25);
			@include gutter('padding-bottom',0.25);
			// padding: $line-sm;
			position: absolute;
			// top: 100%;
			transition: opacity 250ms $easing-material;
			z-index: 2;

			&--error {
				background-color: lighten(color_('alert','error'),55);
				border-color: color_('alert','error');
				color: color_('alert','error');
			}

			.has-focus & {
				opacity: 1;
			}
		}

		&.select {
			position: relative;

			&:after {
				bottom: 0;
				color: color_('text','light');
				content: '\25bc';
				font-size: 10px;
				pointer-events: none;
				position: absolute;
				right: $line-sm;
				transform: translate3d(0,-50%,0);
				z-index: 10;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/FancyInput.vue